import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={idx} className="flex items-center gap-1.5 whitespace-nowrap">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary-400 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-200" : ""} aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-700"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}